<template lang="pug">
  .component-client-smart-edit
    label Document Type
      selectize-document-type(@optionSelected="selectDocType", :selected-value="item.type.id")
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit

</template>
<script type="text/babel">
  import SmartEdit from 'components/structure/SmartEdit'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import DatePicker from 'components/structure/DatePicker.vue'
  import SelectizeDocumentType from '../../structure/ui/lists/selectize/SelectizeDocumentType'

  export default {
    name: 'DriverLicenseSmartEdit',
    components: {
      SelectizeDocumentType,
      DatePicker,
      SmartEdit
    },
    data() {
      return {
        documentType: null,
        body: {},
      }
    },
    created() {
      this.$set(this.body, 'body', this.item)

    },
    methods: {
      selectDocType(obj) {
        this.documentType = obj
        this.$set(this.item, 'document_type_id', obj.id)
        this.$set(this.item.type, 'id', obj.id)

      },
      updateFields(item) {
        this.item = item
      },
      edit() {
        this.$set(this.item, 'document_type_id', this.item.type.id)
        KeplerBackofficeSdk.documents.select(this.item.id).edit(this.item, (data) => {
          location.reload()
        })
      }
    },
    computed: {

      options() {
        let options = {
          translations: {},

          types: {
            'expiry_date': 'date',
            'issue_date': 'date',
          },
          disabled: [
            'id',
            'status',
            'created',
          ],

          list: [
            'id',
            'uid',
            'driver',
            'attachments',
            'status',
            'type',
            'document_type_id'
          ],
          listMode: 'blacklist',
        }

        const docType = this.documentType
        if (docType) {
          if (!docType.has_expiry) {
            options.list.push('expiry_date')
          }

          if (!docType.has_emission) {
            options.list.push('issue_date')
          }

          if (!docType.has_issuer) {
            options.list.push('issuer')
          }

          if (!docType.has_country) {
            options.list.push('issuer_country')
          }
        }

        return options
      }

    },
    props: [
      'item'
    ]
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverLicenseEdit.vue?1ac8f266